export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAILER = 'ACTIVATION_FAILER';
export const USER_INFO_REG_SUCCESS = 'USER_INFO_REG_SUCCESS';
export const USER_INFO_REG_FAILER = 'USER_INFO_REG_FAILER';
export const USER_INFO_REG_REQUEST = 'USER_INFO_REG_REQUEST';
export const COMPANY_INFO_REG_SUCCESS = 'COMPANY_INFO_REG_SUCCESS';
export const COMPANY_INFO_REG_FAILER = 'COMPANY_INFO_REG_FAILER';
export const COMPANY_INFO_REG_REQUEST = 'COMPANY_INFO_REG_REQUEST';
